import { render, staticRenderFns } from "./VersionHistory.vue?vue&type=template&id=4d36e1c2&scoped=true&"
import script from "./VersionHistory.vue?vue&type=script&lang=js&"
export * from "./VersionHistory.vue?vue&type=script&lang=js&"
import style0 from "./VersionHistory.vue?vue&type=style&index=0&id=4d36e1c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d36e1c2",
  null
  
)

export default component.exports